import React from 'react';
import { cn } from '../cn';
import { accentStyle } from './accents';
/**
 * Controlled tab bar — flat underline style.
 * On a narrow phone the strip scrolls sideways instead of widening the page.
 * The bottom rule is an inset shadow (not a border) so the scroll box does not clip the active underline.
 */
export const Tabs = ({ items, value, onChange, accent = 'orange', className }) => {
    const a = accentStyle(accent);
    const handleKeyDown = (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')
            return;
        e.preventDefault();
        const enabled = items.filter((t) => !t.disabled);
        const idx = enabled.findIndex((t) => t.value === value);
        if (idx < 0)
            return;
        const next = e.key === 'ArrowRight'
            ? enabled[(idx + 1) % enabled.length]
            : enabled[(idx - 1 + enabled.length) % enabled.length];
        onChange(next.value);
    };
    return (React.createElement("div", { role: "tablist", "aria-orientation": "horizontal", onKeyDown: handleKeyDown, className: cn('flex min-w-0 max-w-full items-end gap-1 overflow-x-auto overflow-y-hidden shadow-[inset_0_-1px_0_#e5e7eb]', className) }, items.map((tab) => {
        const active = tab.value === value;
        return (React.createElement("button", { key: tab.value, type: "button", role: "tab", "aria-selected": active, disabled: tab.disabled, tabIndex: active ? 0 : -1, onClick: () => onChange(tab.value), className: cn('relative shrink-0 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-inset focus-visible:ring-2', a.tabFocus, active ? a.tabActive : a.tabInactive, tab.disabled && 'cursor-not-allowed opacity-40 hover:border-transparent') }, tab.label));
    })));
};
export default Tabs;
